import React, { useState, useEffect } from 'react'

import { Row, Col, Button, Table } from 'antd'
import { UnorderedListOutlined, WarningOutlined, TableOutlined, OrderedListOutlined } from '@ant-design/icons'

import { getMessage } from '../../util/IntlMessages'
import { api, request } from '../../util/handlerRequestUtil'

import './Import.css'
import moment from 'moment'

const ImportationStatus = ({ setIsModalStatusVisible, carga }) => {
  const [eibCargaDados, setEibCargaDados] = useState({})
  const [eibTipoCarga, setEibTipoCarga] = useState({})
  const [eibItems, setEibItems] = useState([])

  useEffect(() => {
    setEibCargaDados(carga)
    fetchDataTypes(carga.IdTipoCarga)
    fetchEibItems(carga.id)
  }, [])

  const columns = [
    {
      title: 'Linha',
      dataIndex: 'numLinha',
      width: 150
    },
    {
      title: 'Coluna',
      dataIndex: 'coluna',
      width: 150
    },
    {
      title: 'Descrição do problema',
      dataIndex: 'descricao'
    }
  ]

  async function fetchDataTypes(id) {
    const items = await request(api.getDataTypesId(id))
    setEibTipoCarga(items)
  }

  async function fetchEibItems(idCarga) {
    const items = await request(api.getItemCargaDadosByIdCarga({ idcarga: idCarga }))
    setEibItems(items)
  }

  return (
    <Row gutter={24}>
      <Col span={24} id="container">
        <header>
          {getMessage('ImportationStatus')} - {moment(eibCargaDados.createdAt).format('DD/MM/YYYY HH:mm')}
        </header>
        <section id="top">
          <div className="box">
            <span>
              <TableOutlined />
            </span>
            <p> Tipo de importação</p> <p className="bold">{eibTipoCarga.descricao}</p>
          </div>
          <div className="box">
            <span>
              <OrderedListOutlined />
            </span>
            <p> Total de linhas no arquivo</p> <p className="bold">{eibCargaDados.totalLinhas}</p>
          </div>
          <div className="box">
            <span>
              <UnorderedListOutlined />
            </span>
            <p> Linhas aprovadas</p>
            <p className="bold">{eibCargaDados.numLinhaAcertos}</p>
          </div>
          <div className="box">
            <span>
              <WarningOutlined />
            </span>
            <p>Linhas com erros</p>
            <p className="bold">{eibCargaDados.numLinhasErro}</p>
          </div>
        </section>
        <Table
          columns={columns}
          dataSource={eibItems}
          pagination={{
            pageSize: 10
          }}
          scroll={{
            y: 240
          }}
        />
        <div id="footer">
          <Button
            className="default-header-button button-action"
            type="primary"
            onClick={() => setIsModalStatusVisible(false)}
          >
            {getMessage('cancel')}
          </Button>
        </div>
      </Col>
    </Row>
  )
}

export default ImportationStatus
